import { AutocompleteWithLabel } from '@adotel/components'
import React, { useEffect, useState } from 'react'

import '../../helpers/date'
import { getTranslate } from '../../localization'
import { Channel } from '../../types/channel'
import useStyles from './styles/providerFilters.styles'

interface ChannelFiltersProps {
  channels?: Channel[] | undefined
  loading?: boolean
  autoCompleteChannelsList?: any
  setAutoCompleteChannelsList?: React.Dispatch<any>
  // inputValidFrom: string
  // setInputValidFrom: React.Dispatch<React.SetStateAction<string>>
  // inputValidUntil: string
  // setInputValidUntil: React.Dispatch<React.SetStateAction<string>>
}

const ChannelFilters: React.FC<ChannelFiltersProps> = ({
  channels,
  loading,
  autoCompleteChannelsList,
  setAutoCompleteChannelsList
}) => {
  const classes = useStyles()
  const [selectedChannels, setSelectedChannels] = useState<any[]>([])

  // const [handyChangeValidFrom, setHandyChangeValidFrom] = useState(false)
  // const [handyChangeValidUntil, setHandyChangeValidUntil] = useState(false)
  // const [isValidFromCalendarOpen, setIsValidFromCalendarOpen] = useState(false)
  // const [isValidUntilCalendarOpen, setIsValidUntilCalendarOpen] =
  //   useState(false)
  // const [selectedDateForValidFrom, setSelectedDateForValidFrom] =
  //   useState<DateObject>({})
  // const [selectedDateForValidUntil, setSelectedDateForValidUntil] =
  //   useState<DateObject>({})

  // const wrapperRefValidFrom = useRef<HTMLDivElement | null>(null)
  // const wrapperRefValidUntil = useRef<HTMLDivElement | null>(null)

  // useEffect(() => {
  //   /**
  //    * Alert if clicked on outside of element
  //    */
  //   function handleClickOutside(event: MouseEvent) {
  //     if (
  //       wrapperRefValidFrom.current &&
  //       !wrapperRefValidFrom?.current?.contains(event.target as Node) &&
  //       isValidFromCalendarOpen
  //     ) {
  //       setIsValidFromCalendarOpen(false)
  //     }
  //   }

  //   // Bind the event listener
  //   document.addEventListener('mousedown', handleClickOutside)
  //   return () => {
  //     // Unbind the event listener on clean up
  //     document.removeEventListener('mousedown', handleClickOutside)
  //   }
  // }, [wrapperRefValidFrom, isValidFromCalendarOpen])

  // useEffect(() => {
  //   /**
  //    * Alert if clicked on outside of element
  //    */
  //   function handleClickOutside(event: MouseEvent) {
  //     if (
  //       wrapperRefValidUntil.current &&
  //       !wrapperRefValidUntil?.current?.contains(event.target as Node) &&
  //       isValidUntilCalendarOpen
  //     ) {
  //       setIsValidUntilCalendarOpen(false)
  //     }
  //   }

  //   // Bind the event listener
  //   document.addEventListener('mousedown', handleClickOutside)
  //   return () => {
  //     // Unbind the event listener on clean up
  //     document.removeEventListener('mousedown', handleClickOutside)
  //   }
  // }, [wrapperRefValidUntil, isValidUntilCalendarOpen])

  // useEffect(() => {
  //   if (!handyChangeValidFrom) {
  //     setInputValidFrom(
  //       inputValidFrom
  //         ? inputValidFrom
  //         : selectedDateForValidFrom &&
  //           selectedDateForValidFrom.gregorianStartDate
  //         ? lang === 'en'
  //           ? selectedDateForValidFrom.gregorianStartDate || ''
  //           : selectedDateForValidFrom.jalaaliStartDate || ''
  //         : ''
  //     )
  //   }
  // }, [handyChangeValidFrom, inputValidFrom, selectedDateForValidFrom])

  // useEffect(() => {
  //   if (!handyChangeValidUntil) {
  //     setInputValidUntil(
  //       inputValidUntil
  //         ? inputValidUntil
  //         : selectedDateForValidUntil &&
  //           selectedDateForValidUntil.gregorianStartDate
  //         ? lang === 'en'
  //           ? selectedDateForValidUntil.gregorianStartDate || ''
  //           : selectedDateForValidUntil.jalaaliStartDate || ''
  //         : ''
  //     )
  //   }
  // }, [handyChangeValidUntil, inputValidUntil, selectedDateForValidUntil])

  useEffect(() => {
    if (selectedChannels.length > 0) {
      setAutoCompleteChannelsList?.(
        selectedChannels.map((selectedChannelItem: any) => ({
          value: selectedChannelItem.value,
          label: selectedChannelItem.label,
          code: selectedChannelItem.code,
          checked: true
        }))
      )
    } else {
      setAutoCompleteChannelsList?.([])
    }
  }, [selectedChannels])

  return (
    <div className={classes.root}>
      <div className={classes.calendars}>
        {/* <div className={classes.inputContainer}>
          <InputWithLabel
            value={inputValidFrom}
            onChange={(event) => {
              setHandyChangeValidFrom(true)
              setInputValidFrom(event.currentTarget.value)
            }}
            placeholder={getTranslate('Valid From')}
            inputSize="small"
            noHelperText
            error={!isValidDateFormat(inputValidFrom)}
            endIcon={
              <IconButton
                onClick={() => {
                  // TODO:uncomment this line when active until is ready to show the table
                  // setIsValidFromCalendarOpen(true)
                }}>
                <CalendarTodayIcon />
              </IconButton>
            }
            // TODO:delete disabled when active until is ready to show the table
            disabled
          />
          {isValidFromCalendarOpen && (
            <Fade in={isValidFromCalendarOpen}>
              <div
                className={classes.datePickerContainer}
                ref={wrapperRefValidFrom}>
                <DateRangePicker
                  onChange={(d: DateObject) => {
                    setHandyChangeValidFrom(false)
                    setInputValidFrom('')
                    setSelectedDateForValidFrom(d)
                  }}
                  dateObject={
                    !handyChangeValidFrom
                      ? isValidDateFormat(inputValidFrom)
                        ? lang === 'en'
                          ? inputValidFrom
                            ? {
                                gregorianStartDate: inputValidFrom,
                                jalaaliStartDate:
                                  gregorianToJalaali(inputValidFrom)
                              }
                            : {}
                          : inputValidFrom
                          ? ({
                              gregorianStartDate:
                                jalaaliToGregorian(inputValidFrom),
                              jalaaliStartDate: inputValidFrom
                            } as DateObject)
                          : {}
                        : selectedDateForValidFrom
                      : {}
                  }
                  autoSelectedEndDate
                  range={false}
                  type={lang === 'fa' ? 'jalaali' : 'gregorian'}
                  onDoneClicked={() => setIsValidFromCalendarOpen(false)}
                  numberOfVisibleMonths={1}
                />
              </div>
            </Fade>
          )}
        </div> */}
        {/* <div className={classes.inputContainer}>
          <InputWithLabel
            value={inputValidUntil}
            onChange={(event) => {
              setHandyChangeValidUntil(true)
              setInputValidUntil(event.currentTarget.value)
            }}
            placeholder={getTranslate('Valid Until')}
            inputSize="small"
            noHelperText
            error={!isValidDateFormat(inputValidUntil)}
            endIcon={
              <IconButton
                onClick={() => {
                  // TODO:uncomment this line when active until is ready to show the table
                  // setIsValidUntilCalendarOpen(true)
                }}>
                <CalendarTodayIcon />
              </IconButton>
            }
            // TODO:delete disabled when active until is ready to show the table
            disabled
          />
          {isValidUntilCalendarOpen && (
            <Fade in={isValidUntilCalendarOpen}>
              <div
                className={classes.datePickerContainer}
                ref={wrapperRefValidUntil}>
                <DateRangePicker
                  onChange={(d: DateObject) => {
                    setHandyChangeValidUntil(false)
                    setInputValidUntil('')
                    setSelectedDateForValidUntil(d)
                    // addValidUntilForResource(d.gregorianStartDate || '')
                  }}
                  dateObject={
                    !handyChangeValidUntil
                      ? isValidDateFormat(inputValidUntil)
                        ? lang === 'en'
                          ? inputValidUntil
                            ? {
                                gregorianStartDate: inputValidUntil,
                                jalaaliStartDate:
                                  gregorianToJalaali(inputValidUntil)
                              }
                            : {}
                          : inputValidUntil
                          ? ({
                              gregorianStartDate:
                                jalaaliToGregorian(inputValidUntil),
                              jalaaliStartDate: inputValidUntil
                            } as DateObject)
                          : {}
                        : selectedDateForValidUntil
                      : {}
                  }
                  autoSelectedEndDate
                  range={false}
                  type={lang === 'fa' ? 'jalaali' : 'gregorian'}
                  onDoneClicked={() => setIsValidUntilCalendarOpen(false)}
                  numberOfVisibleMonths={1}
                />
              </div>
            </Fade>
          )}
        </div> */}
      </div>
      <div
        className={[
          classes.selectorContainer,
          classes.selectorContainerFullWidth
        ].join(' ')}>
        <AutocompleteWithLabel
          limitTags={1}
          noHelperText
          multiple
          fullWidth
          value={autoCompleteChannelsList}
          label={getTranslate('Channel')}
          placeholder={getTranslate('Choose Channel')}
          options={
            channels?.map((item) => ({
              label: item.basicDetails.name,
              value: item.basicDetails.channelID || '',
              code: item.basicDetails.displayChannelCode
            })) || []
          }
          onChange={(_, v: any) => {
            if (v.length > 0) {
              const tempSelectedChannels = [
                ...v.map((item: any) => ({
                  value: item.value,
                  label: item.label,
                  code: item.code
                }))
              ]
              setSelectedChannels(tempSelectedChannels)
            } else {
              setSelectedChannels([])
            }
          }}
          getOptionLabel={(option) => option.label || ''}
          getOptionSelected={(option, value) => option.value === value.value}
          loading={loading}
          loadingText={getTranslate('Loading') + '...'}
        />
      </div>
    </div>
  )
}

export default ChannelFilters
